import { select, call, takeEvery } from 'typed-redux-saga';
import * as selectors from '../selectors';
import { track, events } from '@elevio/js-analytics';
import * as PageActions from '../actions/page';
import * as SearchActions from '../actions/search';
const getSearchDetails = (state) => {
    var _a;
    const searchTerm = state.search.searchedTerm;
    const totalAmount = state.search.totalCount;
    const articleIds = ((_a = state.search.results) === null || _a === void 0 ? void 0 : _a.map((a) => a.id)) || [];
    return { searchTerm, totalAmount, articleIds };
};
export function* sendHomePageEvent() {
    yield* call(track, events.pageViewIndex());
}
export function* sendArticlePageEvent(articleId) {
    let article = yield* select(selectors.categoryTree.articleFull, articleId);
    if (article) {
        yield* call(track, events.pageViewArticle({
            articleId: articleId,
            articleTitle: article.title,
        }));
    }
}
export function* sendCategoryPageEvent(categoryId) {
    const category = yield* select(selectors.categoryTree.category, categoryId);
    if (category) {
        yield* call(track, events.pageViewCategory({
            categoryId: categoryId,
            categoryTitle: category.title,
        }));
    }
}
export function* sendSearchResultsEvent(searchTerm, _page) {
    let results = yield* select(getSearchDetails);
    // Results match
    if (results && results.searchTerm === searchTerm) {
        yield* call(track, events.searchQuery({
            searchTerm: searchTerm,
            totalResults: results.totalAmount || 0,
            articleIds: results.articleIds,
        }));
        return;
    }
}
export function* watchPageMount() {
    yield* takeEvery(PageActions.ActionTypes.PAGE_NAV_COMPLETE, function* (action) {
        if (action.payload.pageType === 'home') {
            yield* call(sendHomePageEvent);
        }
        if (action.payload.pageType === 'article') {
            yield* call(sendArticlePageEvent, action.payload.articleId);
        }
        if (action.payload.pageType === 'category') {
            yield* call(sendCategoryPageEvent, action.payload.categoryId);
        }
        if (action.payload.pageType === 'search') {
            yield* call(sendSearchResultsEvent, action.payload.searchTerm, 1);
        }
    });
}
export function* watchSearchResultClick() {
    yield* takeEvery(SearchActions.ActionTypes.SEARCH_RESULT_CLICK, function* (action) {
        const searchTerm = yield* select((state) => state.search.searchedTerm);
        if (!searchTerm)
            return;
        const { articleId, title, index } = action.payload;
        yield* call(track, events.searchClick({
            searchTerm: searchTerm,
            articleId: articleId,
            resultIndex: index,
            articleTitle: title,
        }));
    });
}
//# sourceMappingURL=analytics.js.map